import React from "react";

export function Logo({ size = 32, showWordmark = true }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="40" height="40" rx="10" fill="#0B132B" stroke="#1E293B" />
        <path d="M10 28V12L20 6L30 12V28" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 28V18L20 15.5L24 18V28" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="20" cy="11" r="2" fill="#10B981" />
        <path d="M10 28H30" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      {showWordmark && (
        <span
          className="font-display text-[15px] tracking-[0.14em] font-bold uppercase text-white"
          style={{ letterSpacing: "0.14em" }}
        >
          Zantravika
        </span>
      )}
    </span>
  );
}

export default Logo;
